import { Checkbox as MaterialUiCheckbox } from '@mui/material';
import UntitledIcon from '@payaca/untitled-icons';
import { FunctionComponent, type JSX } from 'react';
import './Checkbox.sass';

type Props = {
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: () => void;
  preventClickPropagation?: boolean;
  id?: string;
  className?: string;
};

const Checkbox: FunctionComponent<Props> = ({
  isChecked,
  isDisabled = false,
  onChange,
  preventClickPropagation,
  id,
  className,
}: Props): JSX.Element => {
  return (
    <div
      className={`checkbox ${isDisabled ? 'disabled' : ''} ${
        isChecked ? 'checked' : ''
      }`}
    >
      <MaterialUiCheckbox
        color="default"
        checked={isChecked}
        //onChange was not firing when it should have been in certain circumstances. Moving onchange functionality to onClick which works in all places and was recmmended on stackOverflow.
        //onChange={onChange}
        onClick={(e) => {
          onChange();
          if (preventClickPropagation) {
            e.stopPropagation();
          }
        }}
        className={className}
        inputProps={{ 'aria-label': 'checkbox', id: `${id}` }}
        disabled={isDisabled}
        checkedIcon={
          <div className="checkmark-wrapper">
            <UntitledIcon name="check" />
          </div>
        }
        icon={<div className="checkmark-wrapper"></div>}
      />
    </div>
  );
};

export default Checkbox;
